// api.js

import { Base64 } from 'js-base64';

const SERVER_URL = 'https://crism.us:8443/santa'
// const SERVER_URL = 'http://localhost:8081/santa';

class UnauthorizedError extends Error {
  constructor(message) {
    super(message);
    this.name = 'UnauthorizedError';
  }
}

async function getUsers() {
  try {
    const response = await fetch(`${SERVER_URL}/users`, {
      method: 'GET',
      headers: createAuthHeaders(),
    });
    return handleResponse(response);
  } catch (error) {
    throw new Error(`Failed to get users: ${error.message}`);
  }
}

async function getUsernames() {
  try {
    const response = await fetch(`${SERVER_URL}/usernames`, {
      method: 'GET',
      headers: createAuthHeaders(),
    });
    return handleResponse(response);
  } catch (error) {
    throw new Error(`Failed to get usernames: ${error.message}`);
  }
}

async function askForItem(username, item) {
  try {
    const response = await fetch(`${SERVER_URL}/users/${username}/asks`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...createAuthHeaders(),
      },
      body: JSON.stringify(item),
    });
    return handleResponse(response);
  } catch (error) {
    throw new Error(`Failed to ask for item: ${error.message}`);
  }
}

async function claimItem(id) {
  try {
    const response = await fetch(`${SERVER_URL}/claims/${id}`, {
      method: 'PUT',
      headers: createAuthHeaders(),
    });
    return handleResponse(response);
  } catch (error) {
    throw new Error(`Failed to claim item: ${error.message}`);
  }
}

async function unclaimItem(id) {
  try {
    const response = await fetch(`${SERVER_URL}/claims/${id}`, {
      method: 'DELETE',
      headers: createAuthHeaders(),
    });
    return handleResponse(response);
  } catch (error) {
    throw new Error(`Failed to unclaim item: ${error.message}`);
  }
}

async function patchItem(id, itemUpdates) {
  try {
    const response = await fetch(`${SERVER_URL}/items/${id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...createAuthHeaders(),
      },
      body: JSON.stringify(itemUpdates),
    });
    return handleResponse(response);
  } catch (error) {
    throw new Error(`Failed to patch item: ${error.message}`);
  }
}

async function deleteItem(id) {
  try {
    const response = await fetch(`${SERVER_URL}/items/${id}`, {
      method: 'DELETE',
      headers: createAuthHeaders(),
    });
    return handleResponse(response);
  } catch (error) {
    throw new Error(`Failed to delete item: ${error.message}`);
  }
}

function createAuthHeaders() {
  const username = sessionStorage.getItem('user');
  const password = sessionStorage.getItem('password');

  if (!username || !password) {
    throw new Error('Username or password not found in sessionStorage.');
  }

  const authString = `${username}:${password}`;
  const encodedAuthString = Base64.encode(authString);

  return {
    Authorization: `Basic ${encodedAuthString}`,
  };
}

async function handleResponse(response) {
  if (!response.ok) {
    if (response.status === 401) {
      throw new UnauthorizedError(`Unauthorized: ${response.status}`);
    } else {
      throw new Error(`Request failed with status: ${response.status}`);
    }
  }

  const responseType = response.headers.get('content-type');

  switch (responseType) {
    case 'application/json':
      return response.json();
    default:
      return null;
  }
}

export { UnauthorizedError, getUsers, getUsernames, askForItem, claimItem, unclaimItem, patchItem, deleteItem };
